(function () {
  const hero = () => {
    const isRTL = getComputedStyle(document.body).direction === "rtl";
    //document.addEventListener("DOMContentLoaded", () => {
    const sections = document.querySelectorAll(
      ".hero-section:not(.hero_initialized)"
    );

    if (sections.length > 0) {
      sections.forEach((section) => {
        const mediaWrapper = section.querySelector(".hero_image-wrapper");
        const content = section.querySelector(".hero_content-wrapper");
        const line = section.querySelector(".hero_line");
        const ticker = section.querySelector(".hero_ticker-wrapper");
        const tickerBlock = section.querySelector(".hero_ticker-block");
        const tickerText = ticker
          ? ticker.querySelector(".hero_ticker-text")
          : null;

        const isInViewport = (el) => {
          const rect = el.getBoundingClientRect();
          return rect.top < window.innerHeight && rect.bottom >= 0;
        };

        const calculateTransition = (word) => {
          const wordLength = word.textContent.trim().length; // The length of the word
          const baseDuration = 1500;
          const totalDuration = baseDuration + wordLength * 50; // We increase the duration depending on the length
          const cubicBezier = "cubic-bezier(.23, 1, .32, 1)";

          return {
            duration: `${totalDuration}ms`,
            easing: cubicBezier,
          };
        };

        // Function to reveal words with intervals
        const revealWords = () => {
          const ticker = document.querySelector(".hero_ticker-box");
          if (!ticker) {
            return;
          }
          const allTickers = ticker.querySelectorAll(".hero_ticker-text");
          let delayOffset = 0;

          allTickers.forEach((currentTicker, tickerIndex) => {
            const wordElements = currentTicker.querySelectorAll(".ticker-word");
            wordElements.forEach((word, wordIndex) => {
              const { duration, easing } = calculateTransition(word);

              setTimeout(() => {
                word.style.transition = `transform ${duration} ${easing}`;
                word.classList.add("visible");
              }, delayOffset + wordIndex * 100); // The interval between words
            });

            // We increase the overall offset after the animation of the current tickerText
            delayOffset += wordElements.length * 100;
          });
        };

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                if (entry.target.classList.contains("hero_line")) {
                  setTimeout(() => {
                    entry.target.classList.add("visible");
                  }, 500);
                } else {
                  entry.target.classList.add("visible");
                }
                //entry.target.classList.add("visible");
                revealWords(entry.target);
                observer.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.01 }
        );

        [content, line, ticker].forEach((element) => {
          if (element) {
            observer.observe(element);
          }
        });

        if (mediaWrapper) {
          const image = mediaWrapper.querySelector("img");
          const video = mediaWrapper.querySelector("video");

          let mediaLoadedCount = 0;
          let totalMedia = 0;

          if (image) {
            totalMedia = 1;
            imagesLoaded(image, function () {
              mediaLoadedCount++;
              if (mediaLoadedCount === totalMedia) {
                image.classList.add("hero_media_loaded");
              }
            });
          }

          if (video) {
            totalMedia = 1;
            if (video.readyState >= 3) {
              mediaLoadedCount++;
              video.classList.add("hero_media_loaded");
            } else {
              video.addEventListener(
                "loadeddata",
                function () {
                  mediaLoadedCount++;
                  video.classList.add("hero_media_loaded");
                },
                { once: true }
              );
            }
          }

          if (totalMedia > 0) {
            observer.observe(mediaWrapper);
          }
        }

        if (ticker && tickerText) {
          const originalText = tickerText.textContent
            .trim()
            .replace(/\s+/g, " ");
          const words = originalText.split(" ");

          tickerText.innerHTML = "";
          words.forEach((word) => {
            const wordElement = document.createElement("span");
            wordElement.classList.add("ticker-word");
            wordElement.textContent = word + " ";
            tickerText.appendChild(wordElement);
          });

          //revealWords(tickerText);

          const screenWidth = 2 * window.innerWidth;
          let tickerWidth = tickerText.offsetWidth;
          let numberOfClones = Math.max(
            3,
            Math.ceil(screenWidth / tickerWidth)
          );

          for (let i = 0; i < numberOfClones; i++) {
            const tickerClone = tickerText.cloneNode(true);
            ticker.appendChild(tickerClone);
          }

          let lastScrollY = window.scrollY;
          let currentTranslateX = 0;

          window.addEventListener("scroll", () => {
            if (isInViewport(section)) {
              const scrollDelta = window.scrollY - lastScrollY;

              let translateXValue = currentTranslateX - scrollDelta * 1;

              if (translateXValue > 0) {
                translateXValue = 0;
              }

              if (Math.abs(scrollDelta) > 0) {
                if (isRTL) {
                  translateXValue = -1 * translateXValue;
                }
                tickerBlock.style.transform = `translateX(${translateXValue}px)`;
              }

              lastScrollY = window.scrollY;
              currentTranslateX = translateXValue;
            }
          });
        }

        section.style.opacity = "1";
        section.classList.add("hero_initialized");
      });
    }
    //});
  };

  document.addEventListener("DOMContentLoaded", function () {
    hero();
    document.addEventListener("shopify:section:load", function () {
      hero();
    });
  });
})();
